import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination'
import { buildPageNumberWindow, totalPages } from '@/lib/list-pagination'
import { cn } from '@/lib/utils'

export type ListPaginationProps = {
  page: number
  pageSize: number
  total: number
  onPageChange: (page: number) => void
  className?: string
  /** Hide when only one page (default true). */
  hideWhenSinglePage?: boolean
}

/** Numbered list footer — wraps shadcn Pagination for Class B list surfaces. */
export function ListPagination({
  page,
  pageSize,
  total,
  onPageChange,
  className,
  hideWhenSinglePage = true,
}: ListPaginationProps) {
  const pageCount = totalPages(total, pageSize)
  if (hideWhenSinglePage && pageCount <= 1) return null

  const window = buildPageNumberWindow(page, pageCount)

  return (
    <Pagination className={cn('pt-4', className)}>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            href="#"
            aria-disabled={page <= 1}
            className={page <= 1 ? 'pointer-events-none opacity-50' : undefined}
            onClick={(event) => {
              event.preventDefault()
              if (page > 1) onPageChange(page - 1)
            }}
          />
        </PaginationItem>
        {window.map((entry, index) =>
          entry === 'ellipsis' ? (
            <PaginationItem key={`ellipsis-${index}`}>
              <PaginationEllipsis />
            </PaginationItem>
          ) : (
            <PaginationItem key={entry}>
              <PaginationLink
                href="#"
                isActive={entry === page}
                onClick={(event) => {
                  event.preventDefault()
                  if (entry !== page) onPageChange(entry)
                }}
              >
                {entry}
              </PaginationLink>
            </PaginationItem>
          ),
        )}
        <PaginationItem>
          <PaginationNext
            href="#"
            aria-disabled={page >= pageCount}
            className={page >= pageCount ? 'pointer-events-none opacity-50' : undefined}
            onClick={(event) => {
              event.preventDefault()
              if (page < pageCount) onPageChange(page + 1)
            }}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}
